// Message types enum for better type safety
export enum MessageType {
    USER = 'user',
    BOT = 'bot',
    COMPLETE = 'complete',
    SQL_RESULT = 'sql_result',
    SUGGESTIONS = 'suggestions',
    SQL_QUERY = 'sql_query',
    PRE_CHAT = 'pre_chat',
    TMP_QUERY = 'tmp_query',
}

// Message interface for better type safety
export interface ChatMessageData {
    type: MessageType;
    text?: string;
    prompt_id?: string;
    semantic_model?: string;
    account_name?: string;
    showFeedback?: boolean; // Flag to control feedback rendering
    data?: any;
    columns?: any;
    sql?: string;
    suggestions?: string[];
    [key: string]: any; // For other properties
}

// Configuration for feedback behavior
export interface FeedbackConfig {
    enabledMessageTypes?: MessageType[]; // Array of message types that should show feedback
}

// Message component props interface
export interface MessageComponentProps {
    message: ChatMessageData;
    executeSQLStatement?: () => void;
    handleSubmitWrapper?: any;
    setPromptId?: any;
    setSqlQuery?: any;
    feedbackConfig?: FeedbackConfig; // Optional feedback configuration
}
